export const supportedLanguageMapping = {
    ENGLISH: 'ENGLISH',
    HINDI: 'हिन्दी',
    BENGALI: 'বাংলা',
    MARATHI: 'मराठी',
    TELGU: 'తెలుగు',
    TAMIL: 'தமிழ்',
    GUJARATI: 'ગુજરાતી',
    KANNDA: 'ಕನ್ನಡ',
    MALAYALAM: 'മലയാളം',
    PUNJABI: 'ਪੰਜਾਬੀ',
    NEPALI: 'नेपाली'
}

export const priorityLanguage = ["ENGLISH", "HINDI", "BENGALI", "MARATHI", "TELGU", "TAMIL", "GUJARATI", "KANNDA", "MALAYALAM", "PUNJABI", "NEPALI"]